export const MESSAGE_BUTTON_BLOCK = 'bb-message-button-card';
export const MESSAGE_BUTTON_BLOCK_CONTAINER = `${MESSAGE_BUTTON_BLOCK}__container`;
export const MESSAGE_BUTTON_BLOCK_ICON = `${MESSAGE_BUTTON_BLOCK}__icon`;
export const MESSAGE_BUTTON_BLOCK_TITLE = `${MESSAGE_BUTTON_BLOCK}__title`;
export const MESSAGE_BUTTON_BLOCK_MESSAGE = `${MESSAGE_BUTTON_BLOCK}__message`;
export const MESSAGE_BUTTON_BLOCK_BUTTON = `${MESSAGE_BUTTON_BLOCK}__button`;
export const MESSAGE_BUTTON_BLOCK_MESSAGE_LINK = `${MESSAGE_BUTTON_BLOCK_MESSAGE}__link`;
